import { type DocumentNode, gql } from '@apollo/client';

const getLibraryCollection: DocumentNode = gql`
  query libraryCollection($name: String, $collectionType: LibraryCollectionCollectionTypeChoices) {
    allCollections(name: $name, collectionType: $collectionType) {
      edges {
        node {
          name
          collectionType
          id
        }
      }
    }
  }
`;

export default getLibraryCollection;
